
























import Vue from "vue";
import { AFormItem, Dropdown, AInput } from "@canvas/componentlibrary";
export default Vue.extend({
  components: { AFormItem, Dropdown, AInput },
  data() {
    return {
      othersFlagValue: false,
      othersInput: "",
    };
  },
  props: {
    value: {
      type: Array,
    },
    options: {
      type: Array,
    },
    validateStatus: {
      type: String,
      default: "success",
    },
    layout: {
      type: String,
      default: "vertical",
    },
    required: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    othersFlag: {
      type: Boolean,
      default: false,
    },
    otherInputValue: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.othersFlagValue = this.othersFlag;
    this.othersInput = this.otherInputValue;
  },
  watch: {
    // Watcher to update the others input value whenever the prop changes.
    otherInputValue: function(newVal, oldVal) {
      this.othersInput = newVal;
    },
  },
  methods: {
    updateInput(value: string) {
      /**
       * Input event
       *
       * @event input
       */
      this.othersInput = value;
      this.$emit("input", value.trim());
    },
    emitChanges(changeEvent: any) {
      if (changeEvent.name.includes("others")) {
        this.othersFlagValue = true;
      } else {
        this.othersFlagValue = false;
        // Make the Others Input Value as empty string whenver the Others value is unchecked
        this.othersInput = "";
      }
      this.$emit("change", changeEvent.name, this.othersFlagValue);
    },
  },
});
